module.exports = __webpack_public_path__ + "img/home.c5c59585.svg";